import { Page, PageHeader } from '../../shared/ui/layout';
import { isManager } from '../../entities/organization';
import { useSession } from '../../entities/session';
import { BookmarksPanel } from '../../features/bookmarks';

export const BookmarksPage = () => {
  const session = useSession();
  const membership = session.data?.memberships.find((entry) => entry.isCurrent);
  const actor =
    session.data && membership ? { userId: session.data.user.id, role: membership.role } : null;

  return (
    <>
      <PageHeader
        width="full"
        title="Bookmarks"
        description="Real requests, kept under a name, to test flows with."
      />
      <Page width="full">
        <BookmarksPanel editable={isManager(actor)} timeZone={session.data?.preferences.timezone} />
      </Page>
    </>
  );
};
